export default __webpack_public_path__ + "static/media/planetarium.24b41aa9.svg";